export default __webpack_public_path__ + "static/media/AddONG.1415cc12.png";